<template>
  <div class="wrap">
    <div class="flex customTabs">
      <div
        v-for="(route, index) in routeRecordArr"
        :key="index"
        class="customTabPane"
        :class="activeName === index + '' ? 'active' : ''"
        @mouseover="handleHover(index)"
        @mouseout="handleOut(index)"
        @click="handleTabClick({ index: index + '' })"
      >
        <div class="content">
          <img :src="getIcon(index, route)" alt="图片" :class="[activeName === index + '' ? 'activation' : 'notActive', route.parent.path === '/standard' ? 'w16' : '']" />
          <span :class="activeName === index + '' ? 'active' : ''">
            {{ route?.child?.routeName || route.routeName }}
          </span>
          <el-button v-show="activeName === index + '' || hoverIndex === index" type="text" @click="removeTab(index + '')">
            <i class="iColor el-icon-close"></i>
          </el-button>
          <div v-show="activeName !== index + '' && hoverIndex !== index" class="placeholder"></div>
        </div>
      </div>
    </div>
    <div class="right" @click="handleCloseTabs" @mouseover="handleBtnHover" @mouseout="handleBtnOut">
      <el-tooltip class="item" effect="light" content="关闭其他" placement="top-start">
        <el-button :class="['closeAll', isBtnhover ? 'closeAllActive' : '']" type="text">
          <svg v-show="!isBtnhover" xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
            <path
              d="M1.70008 0.239852L12.2601 10.7999C12.58 11.1197 12.58 11.4395 12.2601 11.7593L12.2593 11.7601C11.9395 12.08 11.6197 12.08 11.2999 11.7601L0.739852 1.20008C0.420049 0.880279 0.420049 0.560477 0.739852 0.240674L0.740675 0.239852C1.06048 -0.0799506 1.38028 -0.0799506 1.70008 0.239852Z"
              fill="#434C59"
            />
            <path
              d="M12.2602 1.20016L1.7001 11.7602C1.57287 11.8875 1.40032 11.9589 1.2204 11.9589C1.04047 11.9589 0.867917 11.8875 0.740692 11.7602C0.613467 11.633 0.541992 11.4604 0.541992 11.2805C0.541992 11.1006 0.613467 10.928 0.740692 10.8008L11.3008 0.240754C11.3637 0.177745 11.4385 0.127761 11.5208 0.0936576C11.6032 0.0595539 11.6914 0.0419979 11.7805 0.0419922C11.8696 0.0419864 11.9578 0.0595309 12.0401 0.093624C12.1224 0.127717 12.1972 0.177691 12.2602 0.240692C12.3232 0.303693 12.3732 0.378486 12.4073 0.460802C12.4414 0.543118 12.4589 0.631343 12.4589 0.72044C12.4589 0.809536 12.4414 0.897759 12.4073 0.98007C12.3732 1.06238 12.3232 1.13717 12.2602 1.20016Z"
              fill="#434C59"
            />
          </svg>
          <svg v-show="isBtnhover" xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
            <path
              d="M1.70008 0.239852L12.2601 10.7999C12.58 11.1197 12.58 11.4395 12.2601 11.7593L12.2593 11.7601C11.9395 12.08 11.6197 12.08 11.2999 11.7601L0.739852 1.20008C0.420049 0.880279 0.420049 0.560477 0.739852 0.240674L0.740675 0.239852C1.06048 -0.0799506 1.38028 -0.0799506 1.70008 0.239852Z"
              fill="white"
            />
            <path
              d="M12.2602 1.20016L1.7001 11.7602C1.57287 11.8875 1.40032 11.9589 1.2204 11.9589C1.04047 11.9589 0.867917 11.8875 0.740692 11.7602C0.613467 11.633 0.541992 11.4604 0.541992 11.2805C0.541992 11.1006 0.613467 10.928 0.740692 10.8008L11.3008 0.240754C11.3637 0.177745 11.4385 0.127761 11.5208 0.0936576C11.6032 0.0595539 11.6914 0.0419979 11.7805 0.0419922C11.8696 0.0419864 11.9578 0.0595309 12.0401 0.093624C12.1224 0.127717 12.1972 0.177691 12.2602 0.240692C12.3232 0.303693 12.3732 0.378486 12.4073 0.460802C12.4414 0.543118 12.4589 0.631343 12.4589 0.72044C12.4589 0.809536 12.4414 0.897759 12.4073 0.98007C12.3732 1.06238 12.3232 1.13717 12.2602 1.20016Z"
              fill="white"
            />
          </svg>
        </el-button>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
import { isEqual } from "lodash";
export default {
  name: "CustomTabs",
  data() {
    return {
      activeName: "0",
      hoverIndex: null,
      routeRecordArr: [],
      isBtnhover: false
    };
  },
  computed: {
    defalutIcon() {
      return `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 18" fill="currentColor"><path d="M5.816 11.098L2.94 9.454a.576.576 0 0 0-.842.656.58.58 0 0 0 .27.35l2.876 1.642a.575.575 0 0 0 .787-.217.58.58 0 0 0-.216-.79"/><path d="M12.518 6.293a.58.58 0 0 0-.357-1.078.577.577 0 0 0-.213.07L7.443 7.858 2.941 5.286a.577.577 0 0 0-.842.656.58.58 0 0 0 .27.35l4.568 2.61v5.572a.58.58 0 0 0 .865.501.58.58 0 0 0 .289-.501V8.877c0-.017-.009-.032-.011-.051l4.437-2.533z"/><path d="M13.848 12.33c0 .211-.113.404-.293.508l-5.77 3.292a.572.572 0 0 1-.567 0l-5.77-3.292a.583.583 0 0 1-.294-.507V5.136a.58.58 0 0 1 .287-.501l5.767-3.39a.572.572 0 0 1 .58 0l5.773 3.39a.58.58 0 0 1 .287.501v7.195zm.294-8.703L8.37.237a1.72 1.72 0 0 0-1.742 0L.86 3.627A1.746 1.746 0 0 0 0 5.137v7.195c0 .629.336 1.21.879 1.52l5.769 3.29a1.718 1.718 0 0 0 1.703 0l5.77-3.292c.544-.31.88-.89.879-1.52V5.137a1.75 1.75 0 0 0-.86-1.509h.002z"/><path d="M12.309 7.635L9.616 9.228c-.37.22-.673.706-.673 1.083v3.192c0 .377.301.504.673.284l2.693-1.594c.371-.22.673-.705.673-1.082V7.919c0-.377-.3-.505-.673-.284z"/></svg>`;
    }
  },
  watch: {
    $route(newValue, prevValue) {
      this.recordRoute(newValue, prevValue);
    }
  },
  created() {
    this.buildTreeWithReferences();
    this.recordRoute(this.$route);
  },
  methods: {
    getIcon(index, route) {
      if (this.activeName === index + "") {
        if (route.child) {
          return route.child.icon2 || route.icon || this.defalutIcon;
        } else {
          return route.icon2 || route.icon || this.defalutIcon;
        }
      } else {
        if (route.child) {
          return route.child.icon1 || route.icon || this.defalutIcon;
        } else {
          return route.icon1 || route.icon || this.defalutIcon;
        }
      }
    },
    handleOut() {
      this.hoverIndex = null;
    },
    handleHover(index) {
      this.hoverIndex = index;
    },
    handleBtnHover() {
      this.isBtnhover = true;
      console.log("asdasd");
    },
    handleBtnOut() {
      console.log("asdasd1111");
      this.isBtnhover = false;
    },
    handleCloseTabs() {
      this.routeRecordArr = [this.routeRecordArr[this.activeName]];
      this.activeName = "0";
    },

    removeTab(targetName) {
      let activeName = this.activeName;
      if (this.activeName === "0" && this.routeRecordArr.length === 1) return;
      if (activeName === targetName) {
        if (targetName === this.routeRecordArr.length - 1 + "") {
          activeName = this.activeName - 1 + "";
        }
        this.handleTabClick({
          index: activeName
        });
      } else if (targetName < activeName) {
        this.activeName = this.activeName - 1 + "";
      }
      this.routeRecordArr.splice(targetName, 1);
    },

    handleTabClick(tab) {
      if (this.activeName === tab.index) return;
      this.activeName = tab.index;
      this.$router.push({ path: this.routeRecordArr[this.activeName]?.child?.path || this.routeRecordArr[this.activeName].path });
    },
    recordRoute(route, prevRoute = {}) {
      const target = this.wholeFlatRoute.find((routeItem) => routeItem.path === route.path || routeItem.name === route.name);
      const prevTarget = this.wholeFlatRoute.find((routeItem) => routeItem.path === prevRoute.path || routeItem.name === prevRoute.name) || {};

      const isThreeLevel = this.judgeThreeLevelRoute(target);
      const routeInfo = this.getRouteInfo(route, isThreeLevel);

      // 有子级说明会跳转到子级，不能记录当前route
      if (target.children?.length) return;
      // 说明之前的tab已经有这个页面了，直接改变activeName跳转
      const index = this.routeRecordArr.findIndex((item) => isEqual(item, routeInfo));
      if (index !== -1) {
        this.activeName = `${index}`;
        return;
      }
      if (this.judgeUseSameTab(target, prevTarget, isThreeLevel)) {
        this.routeRecordArr.splice(this.activeName, 1, routeInfo);
      } else {
        this.routeRecordArr.push(routeInfo);
        this.activeName = this.routeRecordArr.length - 1 + "";
      }
    },
    getRouteInfo(route, isThreeLevel) {
      const parent = route?.matched?.at(-2) || {};
      if (isThreeLevel) {
        const grandfather = route?.matched?.at(-3) || {};
        const info = {
          path: parent?.fullPath || parent.path,
          name: parent?.name,
          routeName: parent?.meta?.routeName,
          icon: parent?.meta?.icon,
          icon1: parent?.meta?.icon1,
          icon2: parent?.meta?.icon2,
          parent: {
            path: grandfather.fullPath || grandfather.path,
            name: grandfather.name,
            routeName: grandfather?.meta?.routeName,
            icon: grandfather?.meta?.icon,
            icon1: grandfather?.meta?.icon1,
            icon2: grandfather?.meta?.icon2
          },
          child: {
            path: route.fullPath || route.path,
            name: route.name,
            routeName: route?.meta?.routeName,
            icon: route?.meta?.icon,
            icon1: route?.meta?.icon1,
            icon2: route?.meta?.icon2
          }
        };
        console.log(info);

        return info;
      } else {
        const info = {
          path: route.fullPath || route.path,
          name: route.name,
          routeName: route?.meta?.routeName,
          icon: route?.meta?.icon,
          icon1: route?.meta?.icon1,
          icon2: route?.meta?.icon2,
          parent: {
            path: parent?.fullPath || parent.path,
            name: parent?.name,
            routeName: parent?.meta?.routeName,
            icon: parent?.meta?.icon,
            icon1: parent?.meta?.icon1,
            icon2: parent?.meta?.icon2
          }
        };
        return info;
      }
    },
    // 判断已有的三级路由
    judgeThreeLevelRoute(target) {
      return ["/project-setup", "/persondoc", "/enterprisedoc", "/enterpriseDeptDoc", "/printConfiguration", "/revitSet"].includes(target?.parent.path);
    },
    // 判断当前是否需要使用当前的tab
    judgeUseSameTab(target, prevTarget, isThreeLevel) {
      return this.routeRecordArr[this.activeName]?.parent?.path === (isThreeLevel ? target?.parent?.parent.path : target?.parent?.path) && prevTarget.path !== "/applicationAll";
    },

    buildTreeWithReferences() {
      const data = this.$router.getRoutes();
      // 遍历数组，为每个对象找到并设置其父级的 children
      data.forEach((item) => {
        if (item.parent) {
          if (!item.parent.children) {
            item.parent.children = [item];
          } else {
            // 将当前 item 加入其 parent 的 children 数组
            item.parent.children.push(item);
          }
        }
      });

      this.wholeFlatRoute = data;
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/CommonDP/styles/mixin";
.wrap {
  background-color: #eff1f6;
  padding: 0px var(--middle-space) 0 var(--middle-space);
  position: relative;
}
.right {
  position: absolute;
  right: 10px;
  top: 17px;
  .closeAll {
    width: 29px;
    height: 29px;
    border-radius: 8px;
    background: #e5e8f1;
    margin-right: 6px;
  }
  .closeAllActive {
    background: #4777e7;
  }
}
.flex {
  display: flex;
}
.customTabs {
  position: relative;
  background-color: #fafbfe;
  z-index: 999;
  top: 6px;
  .active {
    color: #007af5 !important;
    background-color: #fff;
    .iColor {
      color: #007af5 !important;
    }
  }
  .customTabPane {
    padding: 8px 0px;
    cursor: pointer;

    .content {
      padding: 0px 9px;
      height: 22px;
      display: flex;
      align-items: center;
      border-right: 2px solid #f2f2f2;
      overflow: hidden;
      span {
        font-weight: 400;
        font-size: 14px;
        color: #434c59;
        margin-left: 5px;
      }
      .placeholder {
        width: 24px;
        height: 26px;
      }
      img.activation {
        width: 20px;
        height: 20px;
        filter: drop-shadow($--color-primary 100px -1px);
        transform: translateX(-100px);
      }
      img.notActive {
        width: 20px;
        height: 20px;
        filter: drop-shadow(#666 100px -1px);
        transform: translateX(-100px);
      }
      .w16 {
        width: 16.5px !important;
        height: 16.5px !important;
      }
      .w16.activation {
        filter: drop-shadow($--color-primary 100px 1px);
      }
      .w16.notActive {
        filter: drop-shadow(#666 100px 1px);
      }
    }
    .iColor {
      color: #434c59;
    }
  }
  // .customTabPane:hover {
  // }
}
</style>
